import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import visuallyHidden_module from "./visuallyHidden.module.js";
import { combineClasses } from "../../utilities/combineClasses.js";
const VisuallyHidden = /*#__PURE__*/ forwardRef(({ className, as, testId, ...props }, ref)=>{
    const As = as ?? 'span';
    return /*#__PURE__*/ jsx(As, {
        className: combineClasses(className, visuallyHidden_module.visuallyHidden),
        "data-testid": testId,
        "data-component": "VISUALLY_HIDDEN",
        ...props,
        ref: ref
    });
});
VisuallyHidden.displayName = 'VisuallyHidden';
export { VisuallyHidden, visuallyHidden_module as visuallyHiddenStyles };
